import { useEffect, useMemo, useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { SetupDashboard } from "@/components/SetupDashboard";

const ZONES = [["all", "Tümü"], ["Blue Zone", "Blue Zone"], ["Green Zone", "Green Zone"]];

export default function SetupDashboardPage() {
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [zone, setZone] = useState("all");

  useEffect(() => {
    api.get("/projects").then((r) => { setRows(r.data || []); setLoaded(true); }).catch((e) => { toast.error(apiError(e)); setLoaded(true); });
  }, []);

  const filtered = useMemo(() => rows.filter((p) => zone === "all" || p.zone === zone), [rows, zone]);

  return (
    <div data-testid="admin-setup-dashboard">
      <div className="text-[10px] uppercase tracking-[0.25em] text-slate-400 font-bold">Yönetim</div>
      <h1 className="font-heading text-4xl font-extrabold tracking-tighter mt-1">Setup Dashboard</h1>
      <p className="text-sm text-slate-500 mt-1">{loaded ? `${filtered.length} proje — tüm proje yöneticilerinin kurulum takip görünümü` : "Yükleniyor..."}</p>
      <div className="mt-5 mb-6 flex border border-slate-200 w-fit bg-white">
        {ZONES.map(([k, lbl]) => (
          <button
            key={k}
            type="button"
            onClick={() => setZone(k)}
            data-testid={`setup-dash-zone-${k === "all" ? "all" : k.split(" ")[0].toLowerCase()}`}
            className={`px-4 py-2 text-xs font-bold border-b-2 transition-colors duration-150 ${zone === k ? (k === "Green Zone" ? "text-emerald-600 border-emerald-600" : k === "Blue Zone" ? "text-blue-600 border-blue-600" : "text-slate-900 border-slate-900") : "border-transparent text-slate-400 hover:text-slate-700"}`}
          >
            {lbl} ({rows.filter((p) => k === "all" || p.zone === k).length})
          </button>
        ))}
      </div>
      <SetupDashboard rows={filtered} testidPrefix="admin-setup" editPath="/projects" />
    </div>
  );
}
